module.exports = __webpack_public_path__ + "img/gruppenfotokfjf.f9a899bf.jpg";